import axios from 'axios'
import QS from 'qs'
import Vue from 'vue'

// axios.defaults.baseURL = 'http://jiusetocar.cn';
axios.defaults.baseURL = '/prod-api/jiusecycle';
axios.defaults.timeout = 10000;

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

axios.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    error => {
        this.$message.error('失败')
    }
)


function get(url, params){
  let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))||''
  console.log(userInfo,'userInfo')
  axios.defaults.headers.token = userInfo.token||''
    return new Promise((resolve, reject) =>{
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err.data)
    })
  });
}
function post(url, params) {
  let userInfo = JSON.parse(window.localStorage.getItem('userInfo'))||''
  console.log(userInfo,'userInfo')
  axios.defaults.headers.token = userInfo.token||''
    return new Promise((resolve, reject) => {
         axios.post(url, QS.stringify(params))
        .then(res => {
            resolve(res.data);
        })
        .catch(err =>{
            reject(err)
            this.$router.push('/')
        })
    });
}

Vue.prototype.$get = get;
Vue.prototype.$post = post;



// WEBPACK FOOTER //
// ./src/utils/request.js